import Cookies from 'universal-cookie'

const cookie = new Cookies()
const DOMAIN = process.env.HOST_URL
const domainProps = {
  path: '/',
  domain: DOMAIN,
}
const QONTAK_ONE_COOKIE_KEY = '_qontak-one'

export const isEnableQontakOneSidebar = () => {
  const params = new URLSearchParams(window.location.search)
  const queryQontakOne = params.get('dev-qontak-one')
  if (queryQontakOne === '1') {
    cookie.set(QONTAK_ONE_COOKIE_KEY, '1', domainProps)
  } else if (queryQontakOne === '0') {
    cookie.remove(QONTAK_ONE_COOKIE_KEY, domainProps)
  }
  const cookieQontakOne = cookie.get(QONTAK_ONE_COOKIE_KEY)
  const isEnableQontakOne = cookieQontakOne === '1'
  return isEnableQontakOne
}
